<div class="monex-ultra-container">
    <div class="close-modal" (click)="closeModalWithUnsubscribe()">
        <span>X</span>
    </div>

    <div class="p-4">
        <div id="scroll-container" class="tyc-container" #scrollContainer scrollContainer.scrollTop = 0>
            <label for="TYC" class="p-2 h4"><strong>{{this.translations.TYC_TITLE}}</strong></label>
            <div class="use-and-constrains p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_1}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_1}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_2}}</p>
                <p class="justify-text p-2 italic-underline">{{this.translations.TYC_TEXT_3}}</p>
            </div>
            <div class="uses" p-2>
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_2}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_4}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_5}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_6}}</p>
            </div>
            <div class="limitations p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_3}}</strong></p>
                <p class="justify-text italic-underline p-2">{{this.translations.TYC_TEXT_7}}</p>

            </div>
            <div class="intelectual-property p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_4}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_8}}</p>

            </div>
            <div class="forbidden p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_5}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_9}}</p>

            </div>
            <div class="quality-conection p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_6}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_10}}</p>

            </div>
            <div class="goods-services p-2">
                <p class="justify-text p2 h5"><strong>{{this.translations.TYC_TITLE_7}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_11}}</p>

            </div>
            <div class="privacy p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_8}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_12}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_13}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_14}}</p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_15}}</p>

            </div>
            <div class="cookies p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_9}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_16}}</p>

            </div>
            <div class="access-key p-2">
                <p class="p-2 h5"><strong>{{this.translations.TYC_TITLE_10}}</strong></p>
                <p class="p-2">{{this.translations.TYC_TEXT_17}}</p>

            </div>
            <div class="modifications p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_11}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_18}}</p>

            </div>
            <div class="laws p-2">
                <p class="justify-text p-2 h5"><strong>{{this.translations.TYC_TITLE_12}}</strong></p>
                <p class="justify-text p-2">{{this.translations.TYC_TEXT_19}}</p>
            </div>
            <div class="d-flex gap-3 justify-content-center">
                <button class="btn btn-secondary" (click)="closeModalWithUnsubscribe()">{{this.translations.CLOSE_BTN}}</button>
                <button class="btn btn-primary" [ngClass]="{'d-flex align-items-center gap-2': loading}" [disabled]="loading" (click)="validToken()"><!--acceptTermsAndConditions()-->
                    <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
                    {{this.translations.ACCEPT_TERMS}}
                </button>
            </div>
        </div>
    </div>
</div>
